// extracted by mini-css-extract-plugin
module.exports = {"cell":"Cell_cell__38Xv6","cellSelected":"Cell_cellSelected__1feqj"};